import axios, { InternalAxiosRequestConfig } from 'axios';
import { loginRequest } from '../../services/userService';
import { useAccount, useMsal } from '@azure/msal-react';
import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';

interface IProps {
  children: JSX.Element;
}

function RequestInterceptor({ children }: IProps) {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

  axios.interceptors.request.use(async (config: InternalAxiosRequestConfig<any>) => {
    if (!account) {
      throw Error('No active account! Verify a user has been signed in.');
    }

    const accessTokenRequest = { ...loginRequest, account };
    try {
      const response = await instance.acquireTokenSilent(accessTokenRequest);
      config.headers.Authorization = `Bearer ${response.idToken}`;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) {
        instance.acquireTokenRedirect(accessTokenRequest);
      } else {
        throw error;
      }
    }

    return config;
  });

  return <>{children}</>;
}

export default RequestInterceptor;
